// extracted by mini-css-extract-plugin
module.exports = {"main":"cardsParallax_main__yew3Q"};